const DEFAULT_SIGNUP_REDIRECT_URL = 'https://ieum-auto.in/realtorauto/';

const SIGNUP_REDIRECT_PARAM_KEYS = ['continueUrl', 'returnTo', 'continue'];

const ALLOWED_SIGNUP_REDIRECT_HOSTS = new Set([
  'ieum.in',
  'www.ieum.in',
  'ieum-auto.in',
  'www.ieum-auto.in',
  'ieum-8fd99.web.app',
  'ieum-8fd99.firebaseapp.com',
]);

const getBaseOrigin = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://ieum-8fd99.web.app';
};

const getDocumentReferrer = () => {
  if (typeof document !== 'undefined' && document.referrer) {
    return document.referrer;
  }
  return '';
};

export const normalizeSignupRedirectUrl = (rawUrl) => {
  const value = String(rawUrl || '').trim();
  if (!value) return '';

  try {
    const url = new URL(value, getBaseOrigin());
    const hostname = url.hostname.toLowerCase();
    if (url.protocol !== 'https:') return '';
    if (!ALLOWED_SIGNUP_REDIRECT_HOSTS.has(hostname)) return '';
    return url.href;
  } catch {
    return '';
  }
};

export const isRealtorAutoConnectRedirect = (rawUrl) => {
  const safeUrl = normalizeSignupRedirectUrl(rawUrl);
  if (!safeUrl) return false;
  try {
    const parsed = new URL(safeUrl);
    return (
      ['ieum-8fd99.web.app', 'ieum-8fd99.firebaseapp.com'].includes(parsed.hostname.toLowerCase()) &&
      parsed.pathname === '/realtorauto/connect'
    );
  } catch {
    return false;
  }
};

export const getSafeSignupRedirect = (
  searchParams,
  fallbackUrl = DEFAULT_SIGNUP_REDIRECT_URL
) => {
  const params = searchParams instanceof URLSearchParams
    ? searchParams
    : new URLSearchParams(searchParams || '');

  for (const key of SIGNUP_REDIRECT_PARAM_KEYS) {
    const safeUrl = normalizeSignupRedirectUrl(params.get(key));
    if (safeUrl) return safeUrl;
  }

  const safeReferrer = normalizeSignupRedirectUrl(getDocumentReferrer());
  if (safeReferrer) return safeReferrer;

  return fallbackUrl;
};
